import { render, staticRenderFns } from "./achatFacture.vue?vue&type=template&id=480447f6&"
import script from "./achatFacture.vue?vue&type=script&lang=js&"
export * from "./achatFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports